const getters = {
  getFilteredScheduleListByAddress: state => (arr) => {
    let copyArray = JSON.parse(JSON.stringify(arr));
    return copyArray.map(itemList => {
      itemList.classes = itemList.classes.filter(itemClass =>
          state.filterAddress.includes(itemClass.address.id),
      );
      return itemList;
    }).filter(item => item.classes.length);
  },
  getFilteredScheduleListByDate: (state) => {
    if (state.filterDate) {
      let copyArray = JSON.parse(JSON.stringify(state.schedule.list));
      return copyArray.map(itemList => {
        itemList.classes = itemList.classes.filter(itemClass => {
              return state.filterDate.includes(parseDateUniversal(itemClass.date));
            },
        );
        return itemList;
      }).filter(item => item.classes.length);
    }
  },
  getFilteredScheduleList: (state, getters) => {
    if (state.filterAddress.length) {
      return getters.getFilteredScheduleListByAddress(getters.getFilteredScheduleListByDate);
    } else {
      return getters.getFilteredScheduleListByDate;
    }
  },
  getFilteredScheduleListBySearch: (state, getters) => {
    if (state.filterSearch.length >= 3) {
      const strRegExp = state.filterSearch.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
      return getters.getFilteredScheduleList.filter(item => !!item.name ? [...item.name.matchAll(new RegExp(strRegExp, 'ig'))].length : false);
    } else {
      return getters.getFilteredScheduleList;
    }
  },
  getFilteredScheduleListBySearchAndDate: (state, getters) => {
    if (state.filterSearch.length >= 3) {
      const strRegExp = state.filterSearch.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
      return getters.getFilteredScheduleListByDate.filter(item => !!item.name ? [...item.name.matchAll(new RegExp(strRegExp, 'ig'))].length : false);
    } else {
      return getters.getFilteredScheduleList;
    }
  },
  getFilteredScheduleListBySearchAllDate: (state) => {
    if (state.filterSearch.length >= 3) {
      const strRegExp = state.filterSearch.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
      return state.schedule.list.filter(item => !!item.name ? [...item.name.matchAll(new RegExp(strRegExp, 'ig'))].length : false);
    }
  },
};
export default {
  ...getters,
};

function parseDateUniversal(dateStr) {
  const date = new Date(dateStr.slice(0, 10));
  const dateTime = date.getTime();
  const dateTimeZone = date.getTimezoneOffset() * 60000;
  return dateTime + dateTimeZone;
}
